<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addLookBookTopic">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <div>
        <a-row :gutter="20">
          <a-col
            :span="4"
            v-for="item in table.data"
            :key="item.id">
            <a-card
              style="margin-bottom: 20px"
              hoverable>
              <img
                slot="cover"
                alt="example"
                class="cover-img"
                :src="item.coverPath"
              />
              <template slot="actions" class="ant-card-actions">
                <a-icon type="edit" @click="editLookBookTopic(item.id)"></a-icon>
                <a-icon type="eye"  @click="detailTopic(item.id)"/>
                <a-icon type="close" @click="deleteLookBookTopic(item.id)">
                </a-icon>
                <a-icon type="left" @click="upLookBookTopic(item.id)">
                </a-icon>
                <a-icon type="right" @click="downLookBookTopic(item.id)">
                </a-icon>
              </template>
              <a-card-meta :title="item.name">
              </a-card-meta>
            </a-card>
          </a-col>
        </a-row>
      </div>
    </div>
    <a-modal
:footer="null"
             title="Look Book 主题编辑"
             v-model="form.visible">
      <lookBookTopic-edit
        v-if="form.visible"
        :look-book-topic-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </lookBookTopic-edit>
    </a-modal>

    <a-drawer
      title="活动商品"
      placement="right"
      :closable="false"
      width="60%"
      :destroyOnClose="true"
      @close="()=>{goodsForm.visible = false}"
      :visible="goodsForm.visible"
    >
      <look-book-topic-items
        v-if="goodsForm.visible"
        :topic-id="goodsForm.data.id">
      </look-book-topic-items>
    </a-drawer>
  </a-card>
</template>

<script>
import {
  _queryLookBookTopics,
  _deleteLookBookTopic,
  _upLookBookTopic,
  _downLookBookTopic,
} from '@/api/lookBookTopicApi';
import LookBookTopicEdit from './LookBookTopicEdit.vue';
import LookBookTopicItems from './LookBookTopicItems.vue';

async function getLookBookTopicList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryLookBookTopics({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
}

function addLookBookTopic() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editLookBookTopic(topicId) {
  this.form.data.id = topicId;
  this.form.visible = true;
}

function detailTopic(topicId) {
  this.goodsForm.data.id = topicId;
  this.goodsForm.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getLookBookTopicList();
}

async function deleteLookBookTopic(topicId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteLookBookTopic(topicId);
      this.$message.success('删除成功');
      await this.getLookBookTopicList();
    },
  });
}

async function upLookBookTopic(topicId) {
  this.$confirm({
    title: '是否上移？',
    content: '',
    onOk: async () => {
      await _upLookBookTopic(topicId);
      this.$message.success('上移成功');
      await this.getLookBookTopicList();
    },
  });
}

async function downLookBookTopic(topicId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _downLookBookTopic(topicId);
      this.$message.success('下移成功');
      await this.getLookBookTopicList();
    },
  });
}

export default {
  name: 'LookBookTopicList',
  components: { LookBookTopicEdit, LookBookTopicItems },
  data() {
    return {
      goodsForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getLookBookTopicList,
    deleteLookBookTopic,
    editLookBookTopic,
    addLookBookTopic,
    closeForm,
    upLookBookTopic,
    downLookBookTopic,
    detailTopic,
  },
  created() {
    this.getLookBookTopicList();
  },
};
</script>

<style scoped>

</style>
